/*eslint-disable*/ export const messages = JSON.parse("{\"checkbox-group.validation.required\":[\"Vähintään yksi valinta vaaditaan.\"],\"checkbox-group.label.optional\":[\"Valinnainen\"]}");
//# sourceMappingURL=messages.mjs.map